export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserProfile.vue?vue&type=template&id=09e88f81&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/userprofile/UserProfile.vue?vue&type=template&id=09e88f81&scoped=true&
// module id = 1559
// module chunks = 0